import React, { memo, useState, useEffect } from "react";
import Slider from "react-slick";
import HttpHelper from '../service/httpService'

const BrandLogoSliderSection = (props) => {

    const settings = {
        dots: true,
        infinite: true,
        speed: 200,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };

    const [testimonials, setTestimonials] = useState([]);

    const getTestimonials = async () => {
        await HttpHelper.get("website/GetTestimonial").then((response) => {
            if (response.status === 200) {
                setTestimonials(response.data);
            }
        }).catch((error) => {
            console.log(error);
        })
    }


    useEffect(() => {
        getTestimonials();
    }, [])

    return (
        <>
            <div className={`section pt-5 ${props.removeExtra === true ? '' : 'removeExtraSlider'}`} style={{ backgroundColor: props.bgColor }} >
                <div className="container-fluid shape-animate slider-brand-all overflow-hidden">
                    <div className="col-md-12 text-center">
                        <h3 className="mt-4 title">Our Customers Says</h3>
                    </div>
                    <Slider {...settings}>
                        {
                            testimonials && testimonials.length > 0 ? testimonials.map((testimonial, index) => {
                                return (
                                    <div className="w-100 text-center mt-4 mb-4 slider-brand-all-img">
                                        <p className="colorBlack bgContact">
                                            <div className="text-center" dangerouslySetInnerHTML={{ __html: testimonial.description }}></div>
                                            <br />
                                            <br />
                                            <b>
                                                {testimonial.title}
                                                <br />
                                                {testimonial.subTitle}
                                            </b>
                                        </p>
                                    </div>
                                )
                            }) : null
                        }
                    </Slider>

                </div>
            </div>
        </>
    )
}

export default memo(BrandLogoSliderSection);